import { App } from 'antd/es'
import React, { useEffect } from 'react'

import CreatorList from '@/components/shared/creator-list'
import Page from '@/components/shared/page'
import { readAllCreators, setSelectedCreatorId } from '@/redux/creator-actions'
import { selectAccessibleCreators } from '@/redux/creator-selector'
import {
  createAppSelector,
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'

import SendPost from './components/send-post'
import s from './post.module.css'

const selector = createAppSelector(
  [
    selectAccessibleCreators,
    (state) => state.creator.selectedCreatorId,
    (state) => state.global.permissionKey,
    (state) => state.post.postList,
    (state) => state.post.postError,
  ],
  (
    creators,
    selectedCreatorId,
    permissionKey,
    postList,
    postError,
  ) => {
    const selectedCreator = creators.find(({ id }) => id === selectedCreatorId)

    return {
      selectedCreator,
      permissionKey,
      postList,
      postError,
    }
  },
)

export default function BaeNewPost() {
  const { message } = App.useApp()
  const { selectedCreator, permissionKey, postError } = useAppSelector(selector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    void dispatch(readAllCreators({ permissionKey }))
  }, [dispatch, permissionKey])

  useEffect(() => {
    if (selectedCreator?.id) {
      dispatch(setSelectedCreatorId(selectedCreator.id))
    }
  }, [dispatch, selectedCreator?.id])

  useEffect(() => {
    if (postError !== undefined) {
      if (postError) {
        void message.error('Network error.')
      }
    }
  }, [postError, message])

  return (
    <>
      <Page sider={<CreatorList />} contentClassName={s.Content}>
        {selectedCreator && <SendPost creator={selectedCreator} />}
      </Page>
    </>
  )
}
